module.exports = __webpack_public_path__ + "img/apps_17.c73c4cdd.jpg";